import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons';

import './Style.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { WebSelectableItem } from '../../types/AssessmentPageItem';

type CheckboxItemProps = {
  onAddSelectedItem: (item: WebSelectableItem) => void;
  item: WebSelectableItem;
  checked: boolean;
  secondaryQ: boolean;
  questionid: string;
};

export function CheckboxItem({
  onAddSelectedItem,
  item,
  checked,
  secondaryQ,
  questionid,
}: CheckboxItemProps) {
  const optionId = secondaryQ && !item.id.endsWith('_sq') ? `${item.id}_sq` : item.id;
  const domId = `${questionid}_${optionId}`;

  function setCheckedHandler(event: React.ChangeEvent<HTMLInputElement>) {
    const newItem = {
      add: event.target.checked,
      id: item.id,
      title: event.target.title,
      class: '',
    };

    onAddSelectedItem(newItem);
  }

  return (
    <div className="checkbox_item">
      <input
        type="checkbox"
        id={domId}
        name={domId}
        className="fdatacollect"
        onChange={setCheckedHandler}
        title={item.title}
        checked={checked}
      />
      <label htmlFor={domId} id={`${domId}_label`}>
        <FontAwesomeIcon icon={faCheckSquare} className="icon" />
        {item.title}
      </label>
    </div>
  );
}
